export default class OfficeAsyncError extends Error {
  readonly officeErrorCode?: number;
  readonly officeErrorName?: string;

  constructor(officeError: Office.Error | undefined, fallbackMessage: string) {
    super(officeError?.message ?? fallbackMessage);
    this.name = 'OfficeAsyncError';
    this.officeErrorCode = officeError?.code;
    this.officeErrorName = officeError?.name;
  }
}
